import React, { FunctionComponent } from 'react';
import { Spinner } from '@trello/nachos/spinner';
import styles from './LoadingSpinner.less';

export const LoadingSpinner: FunctionComponent = () => {
  return <Spinner centered wrapperClassName={styles.loading} />;
};
